import * as React from "react";
import type { AppPreviewGalleryInternalProps } from "@1js/acui-gallery";
import type {
  AppIconGalleryButtonProps,
  AppIconPreviewGalleryProps,
} from "@1js/acui-gallery-icon";
import { AppIconPreviewGallery } from "@1js/acui-gallery-icon";
import { useV9RibbonIconPreviewGalleryEnabled } from "../../RibbonGallery/Galleries/hooks/useNextRibbonIconPreviewGalleryEnabled";
import type { RibbonControlInternalProps } from "../../RibbonControlProps";
import { RibbonIconPreviewGallery as RibbonIconPreviewGalleryNext } from "./next/RibbonIconPreviewGallery";

export type RibbonIconPreviewGalleryInternalProps = AppIconPreviewGalleryProps &
  AppPreviewGalleryInternalProps<AppIconGalleryButtonProps> &
  RibbonControlInternalProps;

export class RibbonIconPreviewGalleryCurrent extends React.PureComponent<
  RibbonIconPreviewGalleryInternalProps,
  {}
> {
  public render() {
    return (
      <AppIconPreviewGallery
        {...this.props}
        dataAutomationType="RibbonIconPreviewGallery"
        persistMenu={true}
      />
    );
  }
}

export const RibbonIconPreviewGallery = React.forwardRef<
  HTMLDivElement,
  RibbonIconPreviewGalleryInternalProps
>((props, ref) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const isNewPreviewGalleryEnabled = useV9RibbonIconPreviewGalleryEnabled();
  return isNewPreviewGalleryEnabled ? (
    <RibbonIconPreviewGalleryNext {...(props as any)} ref={ref as any} />
  ) : (
    <RibbonIconPreviewGalleryCurrent {...props} ref={ref as any} />
  );
});
